<template>
  <div class="createPost-container">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="form-container"
      :label-width="labelWidth"
      :label-position="formLabelPosition"
    >
      <sticky class-name="sub-navbar" style="height:0px;">
        <editor-button v-if="pageSaveButton" :loading="actionLoading" action="save" @click="handleSave" />
        <editor-button v-if="pageSaveButton" :loading="actionLoading" action="saveClose" @click="saveAndClose" />
        <editor-button :loading="actionLoading" action="cancel" @click="close" />
      </sticky>
      <el-col :xs="24" :md="12" :lg="8" :xl="6">
        <el-card v-loading="pageLoading" class="box-card createPost-header">
          <div class="" v-html="header"></div>
        </el-card>
      </el-col>
      <el-col>
        <div v-loading="pageLoading" class="createPost-tabs">
          <el-alert v-if="disabled" :title="$t('permission.pageIsReadonly')" type="info" :closable="false" /><el-tabs
            type="border-card"
            :before-leave="beforeTabLeave"
          >
            <el-tab-pane
              v-for="(tabColumnsFields, tabIndex) in columnsFields"
              :key="tabIndex"
              :label="tabLabels[tabIndex]"
            >
              <sticky v-if="!!tabSaveButtons[tabIndex]" :class-name="'sub-navbar '">
                <editor-button v-if="!disabled" :loading="actionLoading" action="save" @click="handleSave" />
                <editor-button v-if="!disabled" :loading="actionLoading" action="saveClose" @click="saveAndClose" />
              </sticky>
              <el-row :gutter="20">
                <el-col
                  v-for="(columnFields, columnIndex) in tabColumnsFields"
                  :key="columnIndex"
                  :xs="24"
                  :lg="24 / tabColumnsFields.length"
                >
                  <el-row v-for="(spec, name) in columnFields" :key="name">
                    <el-col>
                      <el-form-item
                        :prop="name"
                        :label="(spec.props.caption && $t(`${spec.props.caption}`)) || $t(`common.${name}`)"
                      >
                        <component
                          :is="spec.type"
                          v-model="form[name]"
                          v-bind="spec.props"
                          :disabled="disabled || !!spec.props.disabled"
                          :maxlength="spec.props.maxlength"
                          :name="name"
                          :required="!!spec.props.required"
                          @init="
                            initialVal => {
                              handleInit(name, initialVal);
                            }
                          "
                        >
                        </component>
                        <input-errors :errors="errors[name.toLowerCase()]" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky'; // Sticky header-component
import editorMixin from './mixins/editor-mixin';
import EditorButton from './EditorButton';
import InputErrors from '@/components/DSE/InputErrors';

export default {
  components: {
    Sticky,
    EditorButton,
    InputErrors
  },
  mixins: [editorMixin],
  data() {
    const definitionGroups = this.definition.groups;
    const fieldsDefinition = [];
    const fieldNames = [];
    let defaultForm = {};
    definitionGroups.forEach(function(definition, index) {
      fieldsDefinition[index] = definition;
      fieldNames[index] = Object.keys(fieldsDefinition[index]);
      defaultForm = Object.assign(
        {},
        fieldNames[index].reduce((form, name) => {
          form[name] = fieldsDefinition[index][name].defaultValue;
          return form;
        }, {})
      );
    });

    return {
      header: '',
      form: defaultForm,
      activeTab: 0
    };
  },
  computed: {
    labelWidth() {
      const showFormLabels = this.definition.showFormLabels || [];
      return showFormLabels[this.activeTab] ? '150px' : '0px';
    },
    rules() {
      const fields = this.fields.reduce((fields, tabFields) => ({ ...fields, ...tabFields }));
      const rules = Object.keys(fields).reduce((rules, key) => {
        rules[key] = fields[key].rules;
        return rules;
      }, {});
      return rules;
    },
    tabLabels() {
      const labels = this.definition.labels;
      return labels.map(e => {
        if (typeof e === 'string') {
          return this.$t(e);
        } else {
          // object
          return this.$t(e.string, { count: this.$store.getters[e.countStoreGetter] });
        }
      });
    },
    pageSaveButton() {
      return !this.disabled && (this.definition.saveButtons ? !!this.definition.saveButtons[0] : true);
    },
    tabSaveButtons() {
      return !this.disabled && (this.definition.saveButtons ? this.definition.saveButtons.slice(1) : []);
    },
    fields() {
      const fieldsDefinition = this.definition.groups;
      const fieldNames = [];
      fieldsDefinition.forEach(function(definition, index) {
        fieldNames[index] = Object.keys(definition);
      });

      const fields = [];
      fieldNames.forEach(function(fieldName, index) {
        const target = {};
        fieldName.reduce((target, name) => {
          const field = fieldsDefinition[index][name];
          if (field.type) {
            target[name] = field;
          }
          return target;
        }, target);
        fields[index] = target;
      });
      return fields;
    },
    columnsFields() {
      const tabColumnsFields = [];
      this.fields.forEach((tabFields, tabIndex) => {
        tabColumnsFields.push(this.splitFieldsInHalfAsArray(tabFields));
      });
      return tabColumnsFields;
    }
  },
  watch: {
    form: {
      deep: true,
      handler: function(val) {
        this.header = this.definition.headerTemplate`${val}`;
      }
    }
  },
  methods: {
    beforeTabLeave(active, old) {
      this.activeTab = active;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/mixin.scss';

.createPost-container {
  position: relative;

  .createPost-main-container {
    padding: 40px 45px 20px 50px;

    .postInfo-container {
      position: relative;
      @include clearfix;
      margin-bottom: 10px;

      .postInfo-container-item {
        float: left;
      }
    }
  }
}

.box-card,
.createPost-tabs {
  margin: 10px;
  border-radius: 0;
  .el-tab-pane {
    padding: 10px 25px 20px 20px;
  }
}
.createPost-header {
  word-wrap: break-word;
}
</style>
<style lang="scss">
.createPost-header {
  h3 {
    margin-block-start: 0;
    margin-block-end: 0;
  }
}
</style>
